<template>
  <div>
    <div v-if="mainStore.module.envoi_chronopost_boutique">
      <div><i>Option de livraison:</i></div>
      <ul v-if="mainStore.module.base == 'BOUTIQUE_VVX24'">
        <li><i>Retrait à l'Orée des Sources au 16 rue des sources à Volvic (63530) du lundi au samedi de 9h à 16h
            (Gratuit)</i></li>
        <li><i>Retrait en point relais Pickup (de 6 à 7€)</i></li>
      </ul>
      <ul v-if="mainStore.module.base == 'BOUTIQUE_VVX25'">
        <li><i>Retrait au 5 rue des Sources 63530 Volvic du lundi au vendredi de 9h à 17h jusqu'au 13 décembre. Puis
            mardi 17 et jeudi 19 décembre, dernier délai (Gratuit)</i></li>
        <li><i>Retrait en point relais Pickup (de 4.50€ à 6.95€)</i></li>

      </ul>

      <label class="field_label">Mode de livraison désiré<span class="text-red">*</span></label>
      <v-select :items="$itemsSelect.mode_livraison()" @change="change_mode_livraison()"
        v-model="livraison_infos.mode" ref="field"></v-select>
      <div v-if="livraison_infos.mode == 'point_relai'">
        <div>Vous pouvez suivre le lien ci-dessous pour rechercher un point relais et nous communiquer ses coordonnées.
        </div>
        <div class="my-2">
          <a href="https://www.chronoshop2shop.fr/shop2shop-en-ligne/#/ou-nous-trouver" target="_blank"><v-btn
              color="primary-dark">Trouver un point relais</v-btn></a>
        </div>

        <label class="field_label">Nom et adresse du point relais souhaité<span class="text-red">*</span></label>
        <v-textarea v-model="livraison_infos.adresse_point_relai"></v-textarea>
      </div>
    </div>
    <div v-else>
      <div><i>Option de livraison:</i></div>
      <div><i>Vos articles vous seront remis sur place</i></div>
    </div>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: ["infos"],
  data() {
    return {
      livraison_infos: {},
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  watch: {
    "livraison_infos.mode": function () {
      this.$emit("updateMode");
    },
  },

  created() {
    this.livraison_infos = this.infos;
  },
};
</script>

<style lang="scss" scoped></style>